import merge from "deepmerge";
import { Colors } from "styles/Colors";
import { Theme } from "../types";

const defaultTheme: Theme = {
	fontFamily: '"Roboto", "Arial", "Helvetica", "sans-serif"',
	transitionTimingFunction: "cubic-bezier(0, 0.92, 0.77, 0.99)",

	disabledColor: "#5D6371",
	matchBackground: {
		wonColor: "rgba(255, 179, 0, 0.14)",
		lostColor: "transparent",
	},
	border: {
		color: "transparent",
		highlightedColor: Colors.pickstop,
	},
	textColor: {
		highlighted: Colors.pickstop,
		winner: Colors.white,
		main: Colors.primary,
		dark: Colors.lightGray,
		disabled: "#5D6371",
	},
	score: {
		text: {
			winner: Colors.panelDark,
			highlightedWonColor: Colors.green,
			highlightedLostColor: Colors.red,
		},
		background: {
			wonColor: Colors.pickstop,
			lostColor: Colors.panelLight,
		},
	},
	canvasBackground: Colors.panelLighterColor,
};

export function createTheme<T>(customTheme?: Theme | T): Theme {
	return merge(defaultTheme, customTheme || {});
}

export default defaultTheme;
